/**
 * Get table headers for viewer or admin.
 *
 * @returns array of table headers.
 */
export const getHeaders = (): string[] => {
  const headers = [
    'Company',
    'Agreement date',
    '# of shares',
    'Investment',
    'Fair value',
    'Gain / loss',
    'Holding',
    'MOIC',
    'IRR',
    'Total raised',
    'Company valuation',
    null,
    'Country',
    'Industry',
    null,
    'Company ID',
    'Investment account',
    'Unrealized account',
    'Interest account',
    'Unrealized account (P&L)',
    'Realized account (P&L)',
    'Interest account (P&L)',
  ];
  return headers;
};

export const getHeadersForLogic = (): string[] => {
  const headers = [
    'Company',
    'Agreement date',
    '# of shares',
    'Investment',
    'Fair value',
    'Gain / loss',
    'Holding',
    'MOIC',
    'IRR',
    'Total raised',
    'Company valuation',
    null,
    'Country',
    'Industry',
    'empty(1)',
    'Company ID',
    'Investment account',
    'Unrealized account',
    'Interest account',
    'Unrealized account (P&L)',
    'Realized account (P&L)',
    'Interest account (P&L)',
  ];
  return headers;
};
